import React from 'react';
import { InfoSection, InfoCard } from '../../components/Info';
import Rocket32 from '@carbon/icons-react/lib/rocket/32';
import Report32 from '@carbon/icons-react/lib/report/32';
import Search32 from '@carbon/icons-react/lib/search/32';
import { Dashboard32 } from '@carbon/icons-react';
import { DataVis_132 as DataVis32 } from '@carbon/icons-react';
import { DocumentExport32 } from '@carbon/icons-react';
import { DataBase32 } from '@carbon/icons-react';
import { DataStructured32 } from '@carbon/icons-react';
import { Chemistry32 } from '@carbon/icons-react';

import { addLineBreaks } from '../../utilities/utility-functions';

// DNA Icon
const Dna32 = () => (
  <svg
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    aria-hidden="true"
    // style={{ willChange: 'transform', transform: 'rotate(45deg)' }}
  >
    <path d="M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"></path>
    <title>Dna</title>
  </svg>
);

export const infoSection = {
  overview: (
    <InfoSection
      heading="The Fields of Application"
      className="landing-page__r3">
      <InfoCard
        heading="Scientific Exploration"
        body={
          'CIRCA provides chemical and biological specific searches as well as easy browsing and filter options to quickly identify ground-truth data sources.'
        }
        icon={<Search32 />}
      />
      <InfoCard
        heading="AI-Guided Discovery"
        body="CIRCA is a source of annotated data in the chemical, biological and materials space to feed into generative models. It offers capabilities for exporting data specific for certain industries or use cases."
        icon={<Rocket32 />}
      />
      <InfoCard
        heading="Intellectual Property Activities"
        body="CIRCA offers advanced prior art searches and competitive analysis with an emphasis on chemical analysis for use in chemical-relevant technologies."
        icon={<Report32 />}
      />
    </InfoSection>
  ),
  efficacy: (
    <div className="landing-page__r3">
      <InfoCard
        heading="Search"
        body="Advanced keyword search, including proximity search, coupled with specific chemical and biological searches, such as chemical similarity or substructure search, reaction search, BLAST search, target assay searches, etc."
        icon={<Search32 />}
      />
      <InfoCard
        heading="Browse"
        body="Snippets, text clustering and statistical analysis makes it easy to browse through the results. Chemically, biological and IP-relevant filter options refine the search to give a targeted result set."
        icon={<Dashboard32 />}
      />
      <InfoCard
        heading="Analytics"
        body="Clustering, claim analysis, chemical understanding, and prediction tools provide AI analysis for various applications and industries. CIRCA is linked to other relevant cognitive IBM applications, enabling more advanced AI capabilities."
        icon={<DataVis32 />}
      />
      <InfoCard
        heading="Export"
        body="Various export options make CIRCA the ideal data source for big data projects. API access makes the integration easy and effortless."
        icon={<DocumentExport32 />}
      />
    </div>
  ),
  complexity: (
    <div className="landing-page__r3">
      <InfoCard
        heading="Data Sources"
        body="All patents from 3 major patent offices (US, EP & WO), open access journal articles, and open access biological relevant data bases (such as ChEMBL, Genebank, Drugbank) and more to come…"
        icon={<DataBase32 />}
      />
      <InfoCard
        heading="Annotation"
        body="A variety of annotation tools extract scientific knowledge, including chemical compounds, polymers, genes, targets, diseases, drugs, effects, substances, reactions, and units."
        icon={<DataStructured32 />}
      />
      <InfoCard
        heading="Chemical & Material Entities"
        body={addLineBreaks(
          '32 M unique chemicals\n4 M chemical reactions\n8,000 polymers\n50,000 drugs'
        )}
        icon={<Chemistry32 />}
      />
      <InfoCard
        heading="Biological Entities"
        body={addLineBreaks('2 M gene sequences\n13,000 targets\n1 M assays')}
        icon={<Dna32 />}
      />
    </div>
  ),
};
